import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';

export const adminAppointmentNoteTemplatesRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/appointment-note-templates',
}).lazy(() =>
  import('pages/admin/AppointmentNoteTemplates/AdminAppointmentNoteTemplatesPage').then(
    (d) => d.Route
  )
);
